import { IconButton } from '@features/shared/components/IconButton'
import { EyeOffIcon } from '@features/shared/icons/icons'
import { useHiddenChanges, useIsHidden } from '../hooks/useHiddenPages'
import { MENU_ICON_SLOT_CLASS } from './menuIconSlots'

export const HIDE_LABEL = 'Hide'
export const UNHIDE_LABEL = 'Unhide'

/**
 * A sidebar row's eye: hides the row's page from the sidebar's menus, or
 * shows it again. Filled (in purple) while the page is hidden, outlined as the
 * action to hide it; the row shows the outlined eye only while hovered. Its
 * click is its own, never the row's link.
 */
export function HiddenToggle({ path, name }: { path: string; name: string }) {
  const isHidden = useIsHidden(path)
  const { hide, unhide } = useHiddenChanges()

  return (
    <IconButton
      label={isHidden ? UNHIDE_LABEL : HIDE_LABEL}
      aria-pressed={isHidden}
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        if (isHidden) unhide(path)
        else hide(path, name)
      }}
      className={`${MENU_ICON_SLOT_CLASS} transition-colors ${
        isHidden
          ? 'tone-purple text-[color:var(--tone-icon)] hover:text-[color:var(--tone-text)]'
          : 'text-[color:var(--sidebar-submenu-text-faintest)] hover:text-[color:var(--sidebar-submenu-text-data)]'
      }`}
    >
      <EyeOffIcon size={14} filled={isHidden} aria-hidden="true" />
    </IconButton>
  )
}
